import { SmsAggregator } from '../core/api/models';

export class AggregatorTypesUiDto {
  type?: SmsAggregator;
  typeNumber?: SmsAggregator;
  colorName?: string;
  color?: string;
  backgroundColor?: string;
  backgroundColorLight?: string;
  backgroundColorDark?: string;
}

const styles = getComputedStyle(document.documentElement);

export const AggregatorTypesUi: AggregatorTypesUiDto[] = [
  {
    type: SmsAggregator.MCI,
    colorName: 'cyan',
    color: styles.getPropertyValue('--color-cyan'),
    backgroundColor: styles.getPropertyValue('--color-cyan-bright'),
    backgroundColorLight: styles.getPropertyValue('--color-cyan-light'),
    backgroundColorDark: styles.getPropertyValue('--color-cyan-dark'),
  },
  {
    type: SmsAggregator.Irancell,
    colorName: 'warning',
    color: styles.getPropertyValue('--color-warning'),
    backgroundColor: styles.getPropertyValue('--color-warning-bright'),
    backgroundColorLight: styles.getPropertyValue('--color-warning-light'),
    backgroundColorDark: styles.getPropertyValue('--color-warning-dark'),
  },
  {
    type: SmsAggregator.Rightel,
    colorName: 'danger',
    color: styles.getPropertyValue('--color-danger'),
    backgroundColor: styles.getPropertyValue('--color-danger-bright'),
    backgroundColorLight: styles.getPropertyValue('--color-danger-light'),
    backgroundColorDark: styles.getPropertyValue('--color-danger-dark'),
  },
  {
    type: SmsAggregator.Other,
    colorName: 'zinc',
    color: styles.getPropertyValue('--color-zinc'),
    backgroundColor: styles.getPropertyValue('--color-zinc-bright'),
    backgroundColorLight: styles.getPropertyValue('--color-zinc-light'),
    backgroundColorDark: styles.getPropertyValue('--color-zinc-dark'),
  },
  {
    type: SmsAggregator.NotValid,
    colorName: 'info',
    color: styles.getPropertyValue('--color-info'),
    backgroundColor: styles.getPropertyValue('--color-info-bright'),
    backgroundColorLight: styles.getPropertyValue('--color-info-light'),
    backgroundColorDark: styles.getPropertyValue('--color-info-dark'),
  },
];
